import { h } from 'preact';
import dlv from 'dlv';

import style from './style';

import SimpleGridCluster from '../../../clusters/simple-grid-cluster';
import { TopBorder } from '../../../pieces/top-border';
import { SadlibAd } from '../../../pieces/sadlib-ad';
import { TaboolaJs } from '../../../pieces/taboola-js';
import { VideoPlayer } from '../../../pieces/video-player';
import { getCommonProps } from '../../../../lib/page';

import { Column, Row, ColumnNoPadding, ContainerFluid } from '@cube/layout';
import { MobileHeader } from '@cube/header-widget';


export const Phone = ({ relatedVideos, pageConfig, browseCategories, shuffledCategories, ...props }) =>
	(
		<div class={style.tablet}>
			<MobileHeader
				{...props}
				{...pageConfig.header}
			/>
			<ContainerFluid>
				<Row>
					<ColumnNoPadding>
						<div class={style.videoWrapper}>
							<div class={style.aspectWrapper}>
								<div class={style.playerWrapper}>
									<VideoPlayer {...props} />
								</div>
							</div>
						</div>
					</ColumnNoPadding>
				</Row>
				<Row>
					<Column>
						<div>
							{ relatedVideos &&
								[
									<TopBorder />,
									<SimpleGridCluster
										title="Related Videos"
										imageRole="w=300,h=169"
										rowCount={3}
										columnCount={2}
										titleLines={3}
										assets={relatedVideos}
									/>
								]
							}
						</div>
						{
							shuffledCategories && shuffledCategories.map( (category, i) => i < dlv(pageConfig, 'clusters.randomDailyMotion.count') && (
								[
									<TopBorder />,
									<SimpleGridCluster
										{...browseCategories[shuffledCategories[i]]}
										{...dlv(pageConfig, 'clusters.randomDailyMotion.clusterProps')}
										isDailyMotion
										titleLines={3}
										{...getCommonProps(props)}
									/>,
									<SadlibAd id={`sc_readvideo_phone_${i+1}`} type="desktopBanner" />
								]
							))
						}
						<TopBorder />
						<TaboolaJs {...dlv(pageConfig, 'taboola.bottomPage')} qeId="sc-readvideo-taboola" />
					</Column>
				</Row>
				<SadlibAd id="adhesion" />
			</ContainerFluid>
		</div>
	);
